import React, { useCallback } from "react";
import styles from "./Tag.module.css";

interface TagProps {
    tag: string;
    onClick?: (tag: string) => void;
}

function Tag({ tag, onClick }: TagProps) {
    const handleClick = useCallback(() => {
        if (onClick && tag) {
            onClick(tag);
        }
    }, [onClick, tag]);

    return (
        <div className={styles.tag} onClick={handleClick}>
            {tag && tag}
        </div>
    );
}

export default Tag;
